<template>
  <!-- 引擎 -->
  <div class="box-main">
    <div class="main">
      <div>
        <div class="main-title">
          <img
            class="arrow-left"
            src="@/assets/img/arrow-left.svg"
            alt=""
            @click="pushBack"
          />
        <span class="ml20">{{ name }}</span>
        </div>
      </div>
      <div>
        <topicList ref="topicList" :sourceId="sourceId"></topicList>
      </div>
    </div>
  </div>
</template>

<script>
import topicList from "@/components/rule-engine/topic/list-info.vue";

export default {
  components: { topicList },
  data() {
    return {
      name:'',
      sourceId:'',
    };
  },
  created() {
    this.name = this.$route.query.name
    this.sourceId = this.$route.query.id
  },
  methods: {
    pushBack() {
      this.$router.push({ name: "/message-forwarding/rule-engine", query: {id:'2'} });
    },
  },
  beforeDestroy() {},
};
</script>
<style lang="scss">
</style>
